import { Component } from "react";
import { DKLabel,DKButton,DKInput, showLoader, removeLoader, showToast, TOAST_TYPE, INPUT_VIEW_DIRECTION, showAlert} from "deskera-ui-library";

import Utility, { deepClone } from "../../../../utility/Utility";
import { MYReportActionButton, MYReportForm, MY_REPORTS } from "./MYReportConstants";
import ReportService from "../../../../services/ReportService";
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import RouteManager, { PAGE_ROUTES } from "../../../../managers/RouteManager";
import { getTenantCountryCode } from "../../../../managers/common/CommonUtil";
import TaxService from "../../../../services/compliance/TaxSerivce";
export default class MYReport extends Component {
    MYReportForm = deepClone(MYReportForm);
    MYReportActionbuttons = deepClone(MYReportActionButton)
    defaultValues = deepClone(this.props.data.defaultValues)
    taxDetailsExist = true
    constructor(props) {
        super(props);
        this.MYReportForm = this.MYReportForm.filter(field=>  this.props.data.fields.findIndex(f=>field.key ==f) != -1)
        let yrInd = this.MYReportForm.findIndex(field => field.key === 'year')
        if (yrInd != -1) {
            this.MYReportForm[yrInd].options = this.props.data.yearOptions;
        }
        let epfAccountInd = this.MYReportForm.findIndex(field => field.key === 'accountId')
        if (epfAccountInd != -1) {
            this.getCPFAAccounts(epfAccountInd) ;
        }
        let userInd = this.MYReportForm.findIndex(field => field.key === 'userId')
        if (userInd != -1) {
            this.getUsers(userInd) ;
        }
        if (this.defaultValues.formType == MY_REPORTS.EA) {
            let monthInd = this.MYReportForm.findIndex(field => field.key === 'month')
            if (monthInd != -1) {
                this.MYReportForm[monthInd].readOnly = true;
            }
        }
        if(this.props.data.actionBtn) {
            this.MYReportActionbuttons = this.MYReportActionbuttons.filter(btn=>this.props.data.actionBtn.findIndex(ab =>ab==btn.key)!=-1)
        }

        window.navigateToPage = (url) => {
            document.getElementById("dk-alert-background")?.remove();
            document.getElementById("dk-alert")?.remove();
            RouteManager.navigateToPage(url);
            
        }
    }
    getUsers(userInd) {
        showLoader()
        ReportService.getUsers().then(res=>{
            
            if(res && res.users) {
                this.MYReportForm[userInd].options = res.users.map(u=>{
                    let obj = {
                        id: u.userId,
                        name: u.name
                    }
                    return obj;
                })
                this.defaultValues['userId'] = TenantService.get(TENANT.USER_ID)
                this.updateState()
                removeLoader()
            }
        })
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    getFieldValue(obj) {
        if(obj.options && obj.options.length!=0) {
            if(obj.options[0].id) {
                return obj.options.find(o=>o.id==this.defaultValues[obj.key])
            } else {
                return obj.options.find(o=>o==this.defaultValues[obj.key])
            }
        }
        return this.defaultValues[obj.key];
    }
    getCPFAAccounts(index) {
        ReportService.getCPFAAccounts({limit:1000,currentPage:1}).then(res=>{
            if(res && res.accounts) {
                this.MYReportForm[index].options = res.accounts.map((acc,index)=>{
                    let obj = {
                        id: acc?.accountId,
                        name: acc?.compliance?.epfAccountName
                    }
                    if(index==0) { // set first EPF account
                        this.defaultValues['accountId'] = obj.id;
                    }
                    return obj;
                })
                this.updateState()
            }
        })
    }
    onChange(value, index, obj) {
        this.defaultValues[obj.key] = (value && value.id) ? value.id : value
    }
    renderFormField(obj, index) {
        return (
            <>
                <DKInput

                    className={"p-v-s mb-r m-h-m "}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={obj.errorMessage}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate}
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    validator={(value) => {
                        if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value);
                            return regex.test(value);
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value)) {
                            obj.isValid = false
                            return false;
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return (obj && obj.name) ? obj.name:obj;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},

                        data: obj.options,
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${((obj && obj.name) ? obj.name:obj)}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                />
            </>
        )
    }
    onButtonClick(btn) {
        if (this.props.onButtonClick) {
            this.props.onButtonClick(btn)
            let param = {
                ...this.defaultValues,
                "form-type": this.defaultValues.formType + ((this.defaultValues.formType != MY_REPORTS.CP8D) ? btn.type: ""),
                "user-id": (this.defaultValues['userId'] ? this.defaultValues['userId'] : TenantService.get(TENANT.USER_ID))
            }
            
            if(param['submissionMedia']) {
                param['submission-media'] = param['submissionMedia']
            }
            showLoader()
            
            ReportService.getStatutoryReport(param).then(response=>{
                removeLoader() 
                saveAs(response, `${this.props.data.fileName ? this.props.data.fileName:this.defaultValues.formType}Form${(btn.type=="_CSV" ? ".csv":"")}`);
                
            },error=>{
                this.getTaxDetails()
                removeLoader()
                
            })
        }
    }

    getTaxDetails() {
        if (this.defaultValues.formType == MY_REPORTS.CP39) {
            if (!this.taxDetailsExist) {
                this.showTaxDetailsAlert()
                      return
            }
            TaxService.getTaxDetail(getTenantCountryCode()).then(res=>{
                showToast("Unable to download",TOAST_TYPE.FAILURE)
                return

            },error=>{
                if (error?.message?.includes("no documents in result")) {
                    this.taxDetailsExist = false
                    this.showTaxDetailsAlert()
                      return
                }
                
            }) 
        } else {
            showToast("Unable to download",TOAST_TYPE.FAILURE)
        }
    }


    showTaxDetailsAlert() {
        const buttons = [
            {
              title: "Ok",
              className: "bg-red text-white ml-r"
            },
          ];

        showAlert(
            "",
            `<div class=''>${`<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:5px'><div class='fs-m cursor-hand' onclick=window.navigateToPage('${PAGE_ROUTES.MY_TAX_DETAILS}')><span class='fw-m'></span> It seems Tax Details isn't filled yet. Please <u class='text-app'>click here</u> to fill it !</div></div>`} </div>`,
            buttons
          );
    }

    getButtons(btn) {
        return (
            <DKButton title={btn.title} icon={btn.icon} className="bg-app text-white border-m m-m" onClick={() => this.onButtonClick(btn)} />
        )
    }
    render() {
        return (
            <>
                <DKLabel className="fw-m fs-l" text={this.props.data.title} />
                <div className="parent-width bg-white border-m mt-l">
                    <div className="d-flex p-m">
                        {this.MYReportForm.map((field, index) => {
                            return <div className="web-width-50 pr-xl">{ this.renderFormField(field, index)}</div>
                        })}
                    </div>
                    <div className="d-flex p-m">
                        {this.MYReportActionbuttons.map((btn) => {
                            return this.getButtons(btn)
                        })}
                    </div>
                </div>
            </>
        )
    }
}